export default __webpack_public_path__ + "static/media/carosello11.2cf993f0.png";